import { getAnalyticsErrorType } from '@zg-rentals/rentals-analytics';
import { logError } from '@zg-rentals/log-error';
import { RenterProfileHasPets } from '@zg-rentals/ts-your-rental-api-client';
import type { RenterInfoClickstreamUser, RenterProfile } from './types';

const nullValues = {
  renter_profile: {
    credit_score_txt: null,
    parking_needed_ind: null,
    pets_ind: null,
    income_txt: null,
    lease_length_txt: null,
    move_in_dt: null,
    bed_cnt_txt: null,
    occupants_cnt_txt: null,
  },
};

export function getRenterProfileInfo(user?: RenterInfoClickstreamUser | null): RenterProfile {
  try {
    if (!user) {
      return nullValues;
    }
    const {
      creditScoreMax,
      creditScoreMin,
      desiredParking,
      hasPets,
      incomeYearly,
      leaseLengthMonths,
      moveInDate,
      numBedrooms,
      numOccupants,
    } = user;
    return {
      renter_profile: {
        credit_score_txt: creditScoreMax && creditScoreMin ? `${creditScoreMin}-${creditScoreMax}` : null,
        parking_needed_ind: desiredParking === 'true',
        pets_ind: hasPets === RenterProfileHasPets.YES,
        income_txt: incomeYearly ? incomeYearly.toString() : null,
        lease_length_txt: leaseLengthMonths ? leaseLengthMonths.toString() : null,
        move_in_dt: moveInDate ? `${moveInDate.year}-${moveInDate.month}-${moveInDate.day}` : null,
        bed_cnt_txt: numBedrooms ? numBedrooms.toString() : null,
        occupants_cnt_txt: numOccupants ? numOccupants.toString() : null,
      },
    };
  } catch (error) {
    logError({ error, errorType: getAnalyticsErrorType('getRenterProfileInfo'), context: { argumentPassed: user } });
    return nullValues;
  }
}
